import React from "react";

const ChevronUpIcon = () => (
	<g>
		<path d='M11.9997 10.8284L7.04996 15.7782L5.63574 14.364L11.9997 8L18.3637 14.364L16.9495 15.7782L11.9997 10.8284Z' />
	</g>
);

export default ChevronUpIcon;
